const Header = () => (
  <header className="header">
    <h1>Your Site Title</h1>
  </header>
);

export default Header;
